module.exports = __webpack_public_path__ + "static/related-payments-0c4c142aed302761e40d9db974c0b258.jpg";